exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.columnBoxInnner[data-v-5bceb4ab] {\n    width: 100%;\n    overflow: hidden;\n    overflow-x: auto;\n    margin-top: 20px;\n    margin-bottom: 10px;\n}\n.columnBoxInnner .columnBoxInnnerList[data-v-5bceb4ab] {\n      white-space: nowrap;\n      padding: 0 20px;\n}\n}\n", ""]);

